var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info-Circle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1.03226C11.8265 1.03226 14.9677 4.13145 14.9677 8C14.9677 11.8481 11.8513 14.9677 8 14.9677C4.15342 14.9677 1.03226 11.8528 1.03226 8C1.03226 4.15474 4.14845 1.03226 8 1.03226L8 1.03226ZM8 0C3.58203 0 0 3.58332 0 8C0 12.4193 3.58203 16 8 16C12.418 16 16 12.4193 16 8C16 3.58332 12.418 0 8 0ZM6.83871 11.0968L7.22581 11.0968L7.22581 7.22581L6.83871 7.22581C6.62494 7.22581 6.45161 7.05248 6.45161 6.83871L6.45161 6.58065C6.45161 6.36687 6.62494 6.19355 6.83871 6.19355L8.3871 6.19355C8.60087 6.19355 8.77419 6.36687 8.77419 6.58065L8.77419 11.0968L9.16129 11.0968C9.37506 11.0968 9.54839 11.2701 9.54839 11.4839L9.54839 11.7419C9.54839 11.9557 9.37506 12.129 9.16129 12.129L6.83871 12.129C6.62494 12.129 6.45161 11.9557 6.45161 11.7419L6.45161 11.4839C6.45161 11.2701 6.62494 11.0968 6.83871 11.0968ZM8 3.35484C7.4299 3.35484 6.96774 3.817 6.96774 4.3871C6.96774 4.95719 7.4299 5.41935 8 5.41935C8.5701 5.41935 9.03226 4.95719 9.03226 4.3871C9.03226 3.817 8.5701 3.35484 8 3.35484Z",
    id: "Icon-Color",
    fill: "current",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.e727dfeaf156c8c33533a27a76959234.svg";
export { ForwardRef as ReactComponent };